export default "__VITE_ASSET__cb13ff80__"